/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, Div, weight } from 'globalStyle';
import { useFormProps, useInvestmentsUser } from 'hooks';
import { ErrorText } from 'components/Form';
import { TextLight } from 'components/Texts';
import { Hollow } from 'components/Buttons';
import { userInvestmentService } from 'services';
import { formatNumber } from 'util/formatNumber';
import { ColorBackgroundTitle } from 'components/Modals/ColorBackgroundTitle';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { CardBalance } from 'Layout/components/Menu/components/AvailableMoney/CardBalance';
import { typesProjectType, projectTypes, isAStockOrTokenProject } from 'types/projectType';
import { calculateAmountStocks } from 'util/calculateAmountStocks';
import { SuccessfulInvestmentModal } from './SuccessfulInvestmentModal';
import InvertInput from './InvertInput';

export const InvertModal = ({
  project,
  userData,
  currentAmount,
  onSuccessfulInvert = () => {},
  goRisk = () => {},
  onClick,
  projectName,
  minInvestmentAmount,
}) => {
  const {
    formProps,
    stateFormProps: {
      isLoading, setLoading, setError, errorMessage,
    },
  } = useFormProps({ errorToolTip: true, requiered: true });

  const { forceUpdateInvestments } = useInvestmentsUser();
  const [successfulInvestment, setSuccessfulInvestment] = useState(false);
  const [amountInvested, setAmountInvested] = useState(0);

  useEffect(
    () => () => {
      setSuccessfulInvestment(false);
      setAmountInvested(0);
    },
    [],
  );

  const submitInvest = (form) => {
    setLoading(true);
    const amount = isAStockOrTokenProject(project?.projectType)
      ? calculateAmountStocks(project, form?.amountStocks)
      : parseInt(form?.amount?.replaceAll('.', ''), 10);
    userInvestmentService({
      amount,
      idProject: project?.projectId,
      isoName: userData?.wallet?.isoName || 'COP',
    })
      .then(() => {
        setLoading(false);
        forceUpdateInvestments();
        setAmountInvested(amount);
        onSuccessfulInvert(currentAmount + amount);
        setSuccessfulInvestment(true);
      })
      .catch(({ message, messageFormat }) => {
        if (message === 'PROJECT_FAST_UPDATED') {
          submitInvest(form);
        }
        setLoading(false);
        setError(true, messageFormat);
      });
  };

  const handleGoRisk = () => {
    onClick();
    goRisk();
  };
  if (successfulInvestment) {
    return (
      <SuccessfulInvestmentModal
        currentAmountAfterInvestment={currentAmount}
        onClick={onClick}
        amountInvested={amountInvested}
        {...project}
      />
    );
  }
  if (!userData) return null;
  const Title = () => (
    <Div
      padding="10px"
      isFlex
      direction="column"
      justify="space-between"
      style={{ minHeight: '90px', maxHeight: '110px' }}
    >
      <TextLight color={colors.WHITE} size={14} align="center">
        {`Inversión en ${typesProjectType[project?.projectType]}`}
      </TextLight>
      <TextLight
        color={colors.WHITE}
        weight={weight.BOLD}
        align="center"
        size={18}
      >
        {capitalizeFirstLetterString(project?.projectName)}
      </TextLight>
    </Div>
  );
  return (
    <ColorBackgroundTitle
      title={<Title />}
      isOpen
      handleBack={() => {
        onClick();
      }}
      handleClose={() => {
        onClick();
      }}
    >
      <Container>
        <Div
          width="50%"
          isFlex
          direction="column"
          align="flex-start"
          justify="space-between"
        >
          <Div>
            <TextLight
              color={colors.primary}
              weight={weight.BOLD}
              align="start"
              mb={5}
              width="auto"
              size={14}
            >
              Total recaudado
            </TextLight>
            <TextLight
              align="start"
              weight={weight.BOLD}
              width="auto"
              size={20}
            >
              {formatNumber(currentAmount, null, project?.currencyIso)}
            </TextLight>
          </Div>
          <Div>
            <TextLight
              color={colors.primary}
              weight={weight.BOLD}
              align="start"
              mb={5}
              width="auto"
              size={14}
            >
              Meta del proyecto
            </TextLight>
            <TextLight
              align="start"
              weight={weight.BOLD}
              width="auto"
              size={20}
            >
              {formatNumber(project?.maxAmount, null, project?.currencyIso)}
            </TextLight>
          </Div>
          <Div>
            <TextLight
              color={colors.primary}
              weight={weight.BOLD}
              align="start"
              mb={5}
              width="auto"
              size={14}
            >
              Tipo de proyecto
            </TextLight>
            <TextLight
              align="start"
              weight={weight.BOLD}
              width="auto"
              size={20}
            >
              {typesProjectType[project?.projectType]}
            </TextLight>
          </Div>
        </Div>
        <Div width="50%" height="100%">
          <CardBalance bgColor={colors.WHITE} colorButton="YELLOW" pd="0" />
        </Div>
      </Container>
      <form
        onSubmit={formProps.handleSubmit(submitInvest)}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          padding: '0 48px',
        }}
      >
        <InvertInput project={project} formProps={formProps} />
        <ErrorText isCenter text={errorMessage} />

        <Div isFlex width="100%" justify="space-evenly" mb={80}>
          <Hollow
            isSubmit
            type="button"
            onColorType="white"
            color={colors.primary}
            onClick={handleGoRisk}
            padding="12px 0"
            size="14px"
            style={{ borderRadius: '30px', width: '220px', height: '45px' }}
          >
            Riesgos
          </Hollow>
          <Hollow
            isSubmit
            onColorType="primary"
            isLoading={isLoading}
            padding="12px 0"
            size="14px"
            style={{ borderRadius: '30px', width: '220px', height: '45px' }}
            disabled={formProps.valid}
          >
            Invertir
          </Hollow>
        </Div>
      </form>
      <Div
        backgroundColor={colors.secondary}
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          padding: '15px 35px',
        }}
      >
        <TextLight size={13} weight={weight.MEDIUM}>
          <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
            Recuerda:
          </span>
          El dinero de tu inversión estará congelado en tu cuenta y solo se
          utilizará para financiar este proyecto. Ten en cuenta que este
          proyecto
          {' '}
          {project?.projectType === projectTypes.EQUITY && (
            <>
              es de
              <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
                RENTABILIDAD VARIABLE
              </span>
              y
            </>
          )}
          {' '}
          tiene unos riesgos, consúltalos y cuando estes listo presiona
          invertir.
        </TextLight>
      </Div>
    </ColorBackgroundTitle>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
  height: 170px;
  padding: 0 50px;
  margin: 20px 0 30px;
  position: relative;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 47%;
    width: 2px;
    height: 100%;
    background-color: ${colors.input.inactive};
  }
`;
